import { createFileRoute, notFound } from '@tanstack/react-router';

import { buildGuards, hasPermission } from '@mint-lib/routing-guards';
import { Conventions } from '@mint-sdk/api-naming-conventions';

const guard = buildGuards(
  hasPermission('namingConventionTraffickingFeature:view'),
);
const oldGuard = buildGuards(hasPermission('namingConventionFeature:view'));

export const Route = createFileRoute(
  '/_secured/company-profile/naming-convention',
)({
  async beforeLoad({ context }) {
    const isNCV3 = await context.isFlagEnabled(
      '@mint/arm',
      'namingConventionV3',
    );
    const guardsContext = await context.getGuardContext(
      await context.getInstance('flagsmith', '@mint/arm'),
    );
    if (isNCV3 && !guard(guardsContext)) {
      throw notFound();
    }
    if (!isNCV3 && !oldGuard(guardsContext)) {
      throw notFound();
    }
  },
  loader: async ({ context }) => {
    const isNCV3 = await context.isFlagEnabled(
      '@mint/arm',
      'namingConventionV3',
    );
    const i18n = await context.getInstance('i18n', '@mint/routing');
    if (isNCV3) {
      await context.getInstance('i18n', '@myn/naming-convention_v3');
      await context.prefetchQuery(
        Conventions.getNamingConventionList({
          params: { type: 'trafficking' },
        }),
      );
      await context.prefetchQuery(Conventions.getSeparators({}));
      await context.prefetchQuery(
        Conventions.getEntityOptions({
          params: { type: 'trafficking' },
        }),
      );
    } else {
      await context.getInstance('i18n', '@myn/naming-convention_v2');
    }

    const title = i18n.t('Naming Convention | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
